import { SyntheticEvent } from 'react';

import { trackExternalLinkEvent } from '../eventService';
import { SyncReactNode } from '../types';

const withHttpProtocol = (url: string) => (/^https?:\/\//.test(url) ? url : `http://${url}`);

type Props = {
  ariaLabel?: string;
  children: SyncReactNode;
  className?: string;
  href: string;
  onClick?: (e: SyntheticEvent) => void;
};

const ExternalLink = ({
  ariaLabel,
  children,
  className,
  href,
  onClick = trackExternalLinkEvent,
}: Props) => (
  <a
    href={withHttpProtocol(href)}
    aria-label={ariaLabel}
    rel="noopener noreferrer"
    target="_blank"
    className={className}
    onClick={onClick}
  >
    {children}
  </a>
);

export default ExternalLink;
